import React from 'react';
import PropTypes from 'prop-types';
//MUI
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
//DS
import DialogBase from '../../atomicos/DialogBase';

const DialogDS = props => {
   const {
      titulo,
      children,
      mensaje,
      onClose,
      accionAceptar,
      aceptarLabel,
      mostrarBotonesAccion,
      ...other
   } = props;
   const procesarAceptar = () => {
      accionAceptar();
   };

   return (
      <DialogBase {...other} onClose={onClose} fullWidth>
         {titulo && <DialogTitle id="form-dialog-title">{titulo}</DialogTitle>}
         <DialogContent dividers={titulo !== '' || mostrarBotonesAccion}>
            {mensaje && (
               <DialogContentText component="span">
                  {mensaje.split('\n').map((item, i) => (
                     <p key={i}>{item}</p>
                  ))}
               </DialogContentText>
            )}
            {children}
         </DialogContent>
         {mostrarBotonesAccion && (
            <DialogActions>
               <Button onClick={onClose} color={accionAceptar ? 'secondary' : 'primary'}>
                  {accionAceptar ? 'Cancelar' : 'Aceptar'}
               </Button>
               {accionAceptar && (
                  <Button onClick={procesarAceptar} color="primary">
                     {aceptarLabel}
                  </Button>
               )}
            </DialogActions>
         )}
      </DialogBase>
   );
};

DialogDS.propTypes = {
   titulo: PropTypes.string,
   mensaje: PropTypes.string,
   onClose: PropTypes.func,
   accionAceptar: PropTypes.func,
   aceptarLabel: PropTypes.string,
   mostrarBotonesAccion: PropTypes.bool
};
DialogDS.defaultProps = {
   aceptarLabel: 'Aceptar',
   mostrarBotonesAccion: true
};

export default DialogDS;
